import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IGridDisplayView, IGridDisplayViewLinks } from "../widget-grid.models";
import { DashboardContextService } from "@main/reporting.v3/dashboard/api/dashboard-context.service";


@Injectable()
export class WidgetGridViewService extends BaseDataService {
    private dashboardContext = inject(DashboardContextService, { optional: true });
    readonly url = "api/reporting3/widget/grid/data";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getDisplayView(widgetSourceId: string): Promise<IGridDisplayView> {
        const headers = this.dashboardContext?.dashboardHeader;

        return this.handleRequest(this.http.get<IGridDisplayView>(`${this.url}/${widgetSourceId}/view`, { headers }));
    }

    getWidgetLinks(gridId: string): Promise<IGridDisplayViewLinks[]> {
        return this.httpGet(`get-widget-links/${gridId}`);
    }
}